const PROMO_CONFIG = {
    selectors: '.promo-cta button, .pdp-promo__cta button',
    colors: ['#fa8900', '#e1001a'],
    rainDuration: 500,
    redirectDelay: 4000
};


function triggerConfettiRain() {
    return new Promise((resolve) => {
        const end = Date.now() + PROMO_CONFIG.rainDuration;

        (function frame() {
            confetti({
                particleCount: 2,
                angle: 60,
                spread: 70,
                origin: { x: 0 },
                colors: PROMO_CONFIG.colors
            });
            confetti({
                particleCount: 2,
                angle: 120,
                spread: 70,
                origin: { x: 1 },
                colors: PROMO_CONFIG.colors
            });

            if (Date.now() < end) {
                requestAnimationFrame(frame);
            } else {
                resolve();
            }
        }());
    });
}


async function handlePromoClick(event) {
    const btn = event.currentTarget;
    const discountCode = btn.dataset.discount;
    const finishText = btn.dataset.finishText || btn.textContent;

    if (!discountCode) return;

    const currentUrl = window.location.pathname + window.location.search;
    const redirectUrl = `/discount/${discountCode}?redirect=${encodeURIComponent(currentUrl)}`;

    try {
        await navigator.clipboard.writeText(discountCode);

        btn.textContent = finishText;
        btn.disabled = true;

        await triggerConfettiRain();

        setTimeout(() => {
            window.location.href = redirectUrl;
        }, PROMO_CONFIG.redirectDelay);

    } catch (err) {
        console.error('Copy failed, redirecting anyway...', err);
        window.location.href = redirectUrl;
    }
}




document.addEventListener("DOMContentLoaded", () => {
    const promoBtns = document.querySelectorAll(PROMO_CONFIG.selectors);
    promoBtns.forEach(btn => btn.addEventListener('click', handlePromoClick));
});